module.exports = __webpack_public_path__ + "static/media/curEquipos.5f4ded26.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curEquipos.png
// module id = 796
// module chunks = 0